
export const ENDPOINTS_ACCOUNT = {
  register_user_email: '/client-account/api/v1/user/registeruseremail'
}